module.exports = __webpack_public_path__ + "media/icons/plain16-c2be8031.png";